function urlReplace(replacements, str) {
  let result = str;
  for (let [x, y] of replacements) {
    result = result.replace(x, y);
  }

  return result;
}

export function createUrlString(string) {
  if (!string) return "";

  let urlString = string.toLowerCase();
  if (urlString) {
    let output = urlReplace(
      [
        [/[!"#$%&'()*+,./\\]/g, ""], // replace specified special characters with empty
        [/\s/g, "-"], // replace whitespaces with '-'
        [/å/g, "a"],
        [/ä/g, "a"],
        [/ö/g, "o"],
      ],
      urlString
    );
    urlString = output;
  }

  return urlString;
}

export function getWebContentIdOfMatchedName(to, from, topics) {
  let webContentIdOfMatchedName = 0;
  if (to.params.componentName) {
    // Compare topic string to request name string
    for (let topic of topics) {
      const modifiedName = createUrlString(topic.name);
      topic.urlName = modifiedName; // Add url-version of name to item state. TODO: unnecessary, remove?

      if (modifiedName === to.params.componentName) {
        webContentIdOfMatchedName = topic.id;
      }
    }
  }

  return webContentIdOfMatchedName;
}

export function getActiveDataType(uniqueDataTypes, paramsDataType) {
  for (let dataType of uniqueDataTypes) {
    if (dataType) {
      let rawDataTypeName = createUrlString(dataType.split(":").pop());
      let rawUrlDataTypeName = createUrlString(paramsDataType);

      if (rawDataTypeName === rawUrlDataTypeName) {
        return dataType;
      }
    } else {
      return;
    }
  }

  return false;
}
